
import React from "react";
import { Box, Typography, Grid, Card, Button, Chip } from "@mui/material";
import { Smartphone, Battery } from "lucide-react";
import { tokens } from "../../theme";
import { useTheme } from "@mui/material";

const ClientList = ({ clients }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const getDeviceIcon = (type) => {
    return <Smartphone size={24} color={colors.primary[500]} />;
  };

  return (
    <Box>
      <Typography 
        variant="h4" 
        sx={{ 
          color: 'var(--fx-text-primary)', 
          fontWeight: 600, 
          mb: 1 
        }}
      >
        Connected Clients
      </Typography>
      <Typography 
        variant="body1" 
        sx={{ 
          color: colors.grey[600],
          mb: 3
        }}
      >
        Real-time status of federated learning clients
      </Typography>

      <Grid container spacing={2}>
        {clients.map((client) => (
          <Grid item xs={12} key={client.id}>
            <Card 
              sx={{ 
                p: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-2px)",
                  boxShadow: "0 8px 25px rgba(18, 86, 103, 0.15)"
                }
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                {getDeviceIcon(client.type)}
                <Box>
                  <Typography 
                    variant="h6" 
                    sx={{ color: 'var(--fx-text-primary)', fontWeight: 600 }}
                  >
                    {client.name}
                  </Typography>
                  <Typography 
                    variant="body2" 
                    sx={{ color: colors.grey[600] }}
                  >
                    Last seen: {client.lastSeen}
                  </Typography>
                </Box>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <Battery size={16} color={colors.grey[600]} />
                  <Typography variant="body2" sx={{ color: colors.grey[600] }}>
                    {client.battery}
                  </Typography>
                </Box>
                
                <Chip 
                  label={client.status}
                  size="small"
                  sx={{ 
                    backgroundColor: client.statusColor,
                    color: "#ffffff",
                    fontWeight: 600,
                    minWidth: "80px"
                  }}
                />
                
                <Button 
                  variant="outlined" 
                  size="small"
                  sx={{
                    borderColor: colors.primary[500],
                    color: 'var(--fx-text-primary)',
                    "&:hover": {
                      backgroundColor: colors.primary[500],
                      color: "#ffffff"
                    }
                  }}
                >
                  Manage
                </Button>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ClientList;
